import {
  Fancybox
} from "@fancyapps/ui";

import ru from "@fancyapps/ui/src/Fancybox/l10n/ru";

import {
  FancyboxOptions
} from "../../../../../const.js";

import InsertView from "../view/insert.js";
import InsertModel from "../model/insert.js";

import {
  loadScript
} from "../../../../../utils/load-script.js";

import {
  defaultInsertModelData,
  InsertType,
  QUIZ_SCRIPT_SRC,
  quizScriptOptions
} from "../../../const.js";
export default class Inserts {
  constructor() {
    this._elements = [];

    this._views = [];
    this._models = [];

    this._handleInsertLinkClick = this._handleInsertLinkClick.bind(this);
    this._handleInsertTitleButtonClick = this._handleInsertTitleButtonClick.bind(this);
    this._handleInsertButtonClick = this._handleInsertButtonClick.bind(this);
    this._handleQuizButtonClick = this._handleQuizButtonClick.bind(this);
  }

  init(elements) {
    this._elements = [];
    this._views = [];
    this._models = [];

    this._elements = elements;
    this._elements.forEach((element, index) => {
      const view = new InsertView(element, index);
      const insertType = view.getType();

      switch (insertType) {
        case InsertType.VIDEO:
          view.setLinkClickHandler(this._handleInsertLinkClick);
          view.setTitleButtonClickHandler(this._handleInsertTitleButtonClick);
          view.setButtonClickHandler(this._handleInsertButtonClick);
          break;
        case InsertType.BANNER_WITH_QUIZ:
          loadScript(QUIZ_SCRIPT_SRC, this._quizCallback, this, quizScriptOptions, view);
          break;
      }

      this._views.push(view);

      const model = new InsertModel(Object.assign(
          {},
          defaultInsertModelData,
          {
            id: view.getId(),
            type: view.getType()
          }
      ));
      this._models.push(model);
    });
  }

  destroy() {
    this._views.forEach((view) => {
      const insertType = view.getType();

      switch (insertType) {
        case InsertType.VIDEO:
          view.removeLinkClickHandler();
          view.removeTitleButtonClickHandler();
          view.removeButtonClickHandler();
          break;
        case InsertType.BANNER_WITH_QUIZ:
          view.removeQuizButtonClickHandler();
          break;
      }
    });

    this._views = [];
    this._models = [];
  }

  _quizCallback(options, view) {
    Marquiz.init(Marquiz);
    view.setQuizButtonClickHandler(this._handleQuizButtonClick);
  }

  _showModal(index) {
    const href = this._views[index].getHref();
    Fancybox.defaults.l10n = ru;

    Fancybox.show(
        [
          {
            src: href,
            type: `video`,
          },
        ],
        Object.assign(
            {},
            FancyboxOptions,
            {
              Html: {
                video: {
                  autoplay: false,
                },
              },
              mainClass: `fancybox-insert-video`
            }
        )
    );
  }

  _handleInsertLinkClick(evt, index) {
    evt.preventDefault();

    this._showModal(index);
  }

  _handleInsertTitleButtonClick(index) {
    this._showModal(index);
  }

  _handleInsertButtonClick(index) {
    this._showModal(index);
  }

  _handleQuizButtonClick() {
    Marquiz.showModal(`63600e5c4c045b004f62fda3`);
  }
}
